export default __webpack_public_path__ + "static/media/avatar.adfc7070.jpg";